// extracted by mini-css-extract-plugin
module.exports = {"sqbr":"Home_sqbr__2tQts","sqtl":"Home_sqtl__-cvpC","heading":"Home_heading__34sqH","sqmenu":"Home_sqmenu__xVOhN"};